import { fromJS } from 'immutable';
import { createSymbols } from 'utils/helpers';
import baseReducer from 'redux/baseReducer';
import { getJwt, saveAdminJwt, setJwt } from 'utils/jwt';

const initialState = fromJS({
    failedApiCalls: [],
    hasResetPassword: false,
    isRefreshing: false,
    jwt: getJwt(),
});

export const {
    BE_ME,
    BE_ME_FAIL,
    BE_ME_SUCCESS,
    BE_USER,
    BE_USER_FAIL,
    BE_USER_SUCCESS,
    CONFIRM_EMAIL,
    CONFIRM_EMAIL_FAIL,
    CONFIRM_EMAIL_SUCCESS,
    LOG_ME_IN,
    LOG_ME_IN_FAIL,
    LOG_ME_IN_SUCCESS,
    REFRESH_TOKEN,
    REFRESH_TOKEN_FAIL,
    REFRESH_TOKEN_SUCCESS,
    REPLAY_FAILED_API_CALLS,
    REPLAY_FAILED_API_CALLS_SUCCESS,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    STORE_FAILED_API_CALL,
} = createSymbols([
    'BE_ME',
    'BE_ME_FAIL',
    'BE_ME_SUCCESS',
    'BE_USER',
    'BE_USER_FAIL',
    'BE_USER_SUCCESS',
    'CONFIRM_EMAIL',
    'CONFIRM_EMAIL_FAIL',
    'CONFIRM_EMAIL_SUCCESS',
    'LOG_ME_IN',
    'LOG_ME_IN_FAIL',
    'LOG_ME_IN_SUCCESS',
    'REFRESH_TOKEN',
    'REFRESH_TOKEN_FAIL',
    'REFRESH_TOKEN_SUCCESS',
    'REPLAY_FAILED_API_CALLS',
    'REPLAY_FAILED_API_CALLS_SUCCESS',
    'RESET_PASSWORD',
    'RESET_PASSWORD_SUCCESS',
    'RESET_PASSWORD_FAIL',
    'STORE_FAILED_API_CALL',
]);

const beUser = (state) => {
    saveAdminJwt();

    return state;
};
const logMeInSuccess = (state, { payload }) => {
    const { token } = payload.data;
    setJwt(token);
    window.location.assign('/');
};
const refreshToken = (state) => state.set('isRefreshing', true);
const refreshTokenFail = (state) => state.set('isRefreshing', false);
const refreshTokenSuccess = (state, action) => logMeInSuccess(
    state.set('isRefreshing', false),
    action
);
const resetPasswordSuccess = (state, action) => logMeInSuccess(
    state.set('hasResetPassword', true),
    action
);
const storeFailedApiCall = (state, { apiCall }) => {
    const failedApiCalls = state.get('failedApiCalls');

    return state.set('failedApiCalls', failedApiCalls.push(apiCall));
};

export default baseReducer(
    initialState,
    {
        [BE_ME_SUCCESS]: logMeInSuccess,
        [BE_USER]: beUser,
        [BE_USER_SUCCESS]: logMeInSuccess,
        [CONFIRM_EMAIL_SUCCESS]: logMeInSuccess,
        [LOG_ME_IN_SUCCESS]: logMeInSuccess,
        [REFRESH_TOKEN]: refreshToken,
        [REFRESH_TOKEN_FAIL]: refreshTokenFail,
        [REFRESH_TOKEN_SUCCESS]: refreshTokenSuccess,
        [RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
        [STORE_FAILED_API_CALL]: storeFailedApiCall,
    }
);
